import { CacheSetIsUseNewChan, CacheGetIsUseNewChan, CacheSessionGetChannel, CacheIsWordOrExcelABTest } from '@/common/cache'
import { channelsKeniuTool, projectType } from '@/common/const'

const getNewType = function () {
  return Math.random() < 0.5
}

export default {
  namespaced: true,
  state: () => ({
    isUseNewChan: false,
  }),
  mutations: {
    vuexChangeIsUseNewChan (state, isUseNewChan) {
      state.isUseNewChan = isUseNewChan
    }
  },
  actions: {
    updateIsUseNewChan ({ commit }) {
      const channel = CacheSessionGetChannel()
      // 仅在可牛工具渠道进行测试
      if (!channelsKeniuTool.includes(channel)) {
        return
      }
      const cache = CacheGetIsUseNewChan()
      if (cache) {
        commit('vuexChangeIsUseNewChan', cache.value)
      } else {
        const type = getNewType()
        CacheSetIsUseNewChan(type)
        commit('vuexChangeIsUseNewChan', type)
      }
    }
  },
  getters: {
    // eslint-disable-next-line max-params
    isWordOrExcelABTest (state, getters, rootState, rootGetters) {
      const isWordOrExcel = rootState.projectType === projectType.word || rootState.projectType === projectType.excel
      return CacheIsWordOrExcelABTest() && isWordOrExcel && rootGetters['channel/isChannelDuba']
    }
  }
}
